import { render, staticRenderFns } from "./modalListarModelos.vue?vue&type=template&id=2993b9c6&scoped=true&lang=pug&"
import script from "./modalListarModelos.vue?vue&type=script&lang=js&"
export * from "./modalListarModelos.vue?vue&type=script&lang=js&"
import style0 from "./modalListarModelos.vue?vue&type=style&index=0&id=2993b9c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2993b9c6",
  null
  
)

export default component.exports